import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import HoneycombAnimation from '@/components/HoneycombAnimation';
import { useAuth } from '@/context/AuthContext';

const UnauthorizedPage = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate('/');
    }
  }, [user, loading, navigate]);

  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100vw',
        position: 'relative',
        background: 'var(--background-color)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <HoneycombAnimation />
      <div style={{
        marginTop: 'calc(38vh + 180px)',
        marginLeft: '-60px',
        textAlign: 'center',
        width: 420,
        maxWidth: '90vw',
        alignSelf: 'center',
        position: 'relative',
        zIndex: 30
      }}>
        <h1 style={{ fontSize: 36, fontWeight: 700, color: 'var(--text-color)', marginBottom: 12 }}>
          Access Denied
        </h1>
        <p style={{ color: 'var(--text-color)', marginBottom: 18 }}>
          You don't have permission to access this page.
        </p>
        <Link
          to="/home"
          style={{
            color: 'var(--primary-color)',
            fontWeight: 700,
            fontSize: 18,
            textDecoration: 'none',
            transition: 'color 0.2s',
          }}
        >
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default UnauthorizedPage;